import { render, staticRenderFns } from "./FormBordered.vue?vue&type=template&id=a0b90e66"
import script from "./FormBordered.vue?vue&type=script&lang=js"
export * from "./FormBordered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports